// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/cavok.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/cavok/cavok.js';

mount([g0]);
